import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ApiService } from 'src/app/api.service';
import { NotifierService } from 'angular-notifier';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { formatDate, DatePipe } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { EnvService } from 'src/app/service/system/env-service';

declare var require: any;

@Component({
  selector: 'app-unknown-request',
  templateUrl: './unknown-request.component.html',
  styleUrls: ['./unknown-request.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class UnknownRequestComponent implements OnInit, OnDestroy {
  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  converstation = [];
  intentSkills = [];
  channel;
  language;
  unknownRequests = [];

  UnknownRequestTable: any =
    {
      dataSource: [],
      pagination:
      {
        pageNo: 1,
        limit: 10,
        totalCount: 100,
        token: null,
        hasNext: false,
        pageSizeOptions: [10, 20],
      },
      columnsToDisplay: ['Sno', 'Timestamp', 'Text', 'Skill assignment', 'Comments', 'Operations'],
      searchText: "",
      searchType: "all",
      sortByCol: "",
      sortByType: "DESC",
      pagedData: [],
      lenght: 1,
    };
  expandedElement: null;
  lastSyncedTime: any = "Not yet";
  panelOpenState = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
  maxDate: Date = new Date();
  maxEndDate: Date = new Date();
  showHideExportDiv: Boolean = false;
  private readonly notifier: NotifierService;

  // Data rage picker
  timeRange = {
    selectionType: '',
    displayNameOfSelected: "",
    displayNameOfSelectionInProgress: "",
    selectedDates: {
      from: null,
      to: null
    },
    maxDate: new Date(),
    nDays: 0,
    selectionKey: null
  };

  @ViewChild('menuDatesFilterTrigger') datesFilterTrigger: MatMenuTrigger;

  private _channelSubscription: Subscription;
  private _languageSubscription: Subscription;

  // Images
  searchImagePath: string = require('../../assets/images/ic_search.svg');
  clearImagePath: string = require('../../assets/images/clear.png');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private service: ApiService, notifierService: NotifierService,
    private env: EnvService, private datePipe: DatePipe, private cdr: ChangeDetectorRef) {
    this.notifier = notifierService;

    let pageFilters = this.getPersistedPageFilters();
    if (pageFilters != null) {
      this._setPredefinedDate(pageFilters);
    }
    else {
      this._setDateFilterToToday();
    }

    this._channelSubscription = this.service.onChannelChanged.subscribe(channel => {
      this.channel = channel.value;
      this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
      this.GetUnknownRequestList();
    });

    this._languageSubscription = this.service.onLanguageChanged.subscribe(lang => {
      this.language = lang.value;
      this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
      this.GetUnknownRequestList();
    });
    // this.maxEndDate.setDate(this.maxEndDate.getDate() + 7);
    this.GetIntentList();
  }

  ngOnInit() {
    this.UnknownRequestTable.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this._channelSubscription.unsubscribe();
    this._languageSubscription.unsubscribe();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    console.log("filterValue ", filterValue);
    return this.intentSkills.filter(option => option.intent.toLowerCase().includes(filterValue));
  }

  GetUnknownRequestList() {
    console.log("==================")
    if (this.channel && this.language) {
      document.getElementById("loaderSpinner").style.display = 'block';
      if (this.getPagedData(this.UnknownRequestTable.pagination.pageNo)) {
        let response = this.getPagedData(this.UnknownRequestTable.pagination.pageNo);
        this.UnknownRequestTable.dataSource = response.results;
        this.UnknownRequestTable.token = response.token;
        this.unknownRequests = response.results.map(x => Object.assign({}, x));
        document.getElementById("loaderSpinner").style.display = 'none';
      } else {
        return this.service.getUnknownRequestList(
          this.timeRange.selectedDates.from,
          this.timeRange.selectedDates.to,
          this.language,
          this.channel,
          this.UnknownRequestTable.pagination.pageNo,
          this.UnknownRequestTable.pagination.limit,
          this.UnknownRequestTable.searchText, this.UnknownRequestTable.searchType,
          this.UnknownRequestTable.sortByCol, this.UnknownRequestTable.sortByType, this.UnknownRequestTable.pagination.token).subscribe((data: {}) => {
            document.getElementById("loaderSpinner").style.display = 'none';
            if (data["status"] == 200) {
              this.UnknownRequestTable.dataSource = data["data"];
              this.unknownRequests = data["data"].map(x => Object.assign({}, x));
              // this.UnknownRequestTable.pagination.totalCount = data["totalCount"];
              // this.lastSyncedTime = data["lastSyncedTime"] || this.lastSyncedTime;
              this.setPagedDate(this.UnknownRequestTable.pagination.pageNo, data["token"], data["data"]);

              if (data["has_next"]) {
                this.UnknownRequestTable.lenght = this.UnknownRequestTable.lenght + this.UnknownRequestTable.pagination.limit;
                this.UnknownRequestTable.pagination.token = data["token"];
              }
            } else {
              this.notifier.notify("error", data["status_details"]);
            }
          })
      }
    }
  }

  private setPagedDate(pageNumber, token, users) {
    if (!this.UnknownRequestTable.pagedData.find(item => item.page == pageNumber)) {
      this.UnknownRequestTable.pagedData.push({ page: pageNumber, token: token, results: users })
    }
  }

  private getPagedData(pageNumber) {
    return this.UnknownRequestTable.pagedData.find(item => item.page == pageNumber);
  }

  public getPaginatorData(event: PageEvent) {
    this.UnknownRequestTable.dataSource.forEach(t => {
      if (t.updated) {
        var edited = this.unknownRequests.find(r => r.document_id == t.document_id);
        if (edited) {
          t.comment = edited.comment;
          t.SkillLabel = edited.SkillLabel;
        }
      }
    });
    if (event.pageSize != this.UnknownRequestTable.pagination.limit) {
      this.resetUnkonwnRequestTable(1, event.pageSize);
    } else {
      this.UnknownRequestTable.pagination.pageNo = event.pageIndex + 1;
      this.UnknownRequestTable.pagination.limit = event.pageSize;
    }
    this.GetUnknownRequestList();
  }

  onStartDateChanged(event) {
    this.maxEndDate.setDate(this.startDate.getDate());
    this.maxEndDate.setMonth(this.startDate.getMonth());
    this.maxEndDate.setFullYear(this.startDate.getFullYear());
    this.maxEndDate.setDate(this.maxEndDate.getDate() + 7);
    this.endDate = this.maxEndDate;
  }

  resetUnkonwnRequestTable(page, length) {
    if (this.paginator) {
      this.paginator.firstPage();
    }
    this.UnknownRequestTable.pagination.pageNo = page;
    this.UnknownRequestTable.pagination.limit = length;
    this.UnknownRequestTable.lenght = length;
    this.UnknownRequestTable.pagedData = [];
    this.UnknownRequestTable.pagination.token = null
  }

  getFilteredValues(event: any) {
    var filteredArray = event;
    var intentSkills = [];

    for (var i = 0; i < filteredArray.length; i++) {
      intentSkills.push(filteredArray[i]);
    }

    for (var i = 0; i < this.intentSkills.length; i++) {
      var intentSkill = filteredArray.filter(e => e.id == this.intentSkills[i].id);
      if (intentSkill.length == 0) {
        intentSkills.push(this.intentSkills[i])
      }
    }

    console.log('intentSkills ', intentSkills)

    this.intentSkills = intentSkills;
    return intentSkills;
  }

  showHideExport() {
    this.showHideExportDiv = !this.showHideExportDiv;
  }

  GetIntentList() {
    return this.service.getIntentList().subscribe((data: {}) => {
      if (data["status"] == 200) {
        this.intentSkills = data["data"];

        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );

      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }

  syncCosmosData() {
    document.getElementById("loaderSpinner").style.display = 'block';
    return this.service.syncUnknownRequestList().subscribe((data: {}) => {
      document.getElementById("loaderSpinner").style.display = 'none';
      if (data["status"] == 200) {
        this.notifier.notify("success", "Imported " + data["data"] + " items succesfully.");
        this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
        this.GetUnknownRequestList();
      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }

  changeSearchText(eveny: any) {
    this.UnknownRequestTable.searchText = event['target']['value'];
    this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
    this.GetUnknownRequestList();
  }

  ClearSearchText() {
    this.UnknownRequestTable.searchText = "";
    this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
    this.GetUnknownRequestList()
  }

  toTimestamp(strDate) {
    var datum = Date.parse(strDate);
    return datum / 1000;
  }

  DeleteUnknownRequestItem(eventId: any) {

    let body = {
      "request_id": eventId
    }

    return this.service.deleteUnknownRequestItem(body).subscribe((data: {}) => {
      if (data["status"] == 200) {
        this.notifier.notify("success", "Deleted succesfully.");
        this.GetUnknownRequestList();
      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }



  UpdateUnknownRequestItem(event: any) {
    console.log("event ", event);
    // if (!event.SkillLabel || event.SkillLabel.trim() == "") {
    //   this.notifier.notify("error", "Skill should not be empty");
    //   return 0;
    // }
    var edited = this.unknownRequests.find(u => u.document_id == event.document_id);
    // document.getElementById("loaderSpinner").style.display = 'block';
    // conversationId: string, documentId: string, trainingPhrase: string, skill:string, comment: string
    if ((!event.SkillLabel || event.SkillLabel.trim() == "") && (!event.comment || event.comment.trim() == "")) {
      event.saved = false;
    } else {
      event.saved = true;
    }
    return this.service.updateUnknownRequestItem(event.conversation_id, event.document_id, event.Text, event.SkillLabel, event.comment).subscribe((data: {}) => {
      // document.getElementById("loaderSpinner").style.display = 'none';
      if (data["status"] == 200 || data["status"] == 201) {
        this.notifier.notify("success", "Updated succesfully.");
        // this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
        // this.GetUnknownRequestList();
        edited.SkillLabel = event.SkillLabel;
        edited.comment = event.comment;
      } else {
        this.notifier.notify("error", data["status_details"]);
        event.saved = false;
      }
      event.updated = false;
    })
  }

  onSelectionChange(event) {
    // event.saved = false;
    event.updated = true;
  }

  onCommentChange(event) {
    if (event.comment == '') {
      event.comment = null;
    }
    // event.saved = false;
    event.updated = true;
  }

  downloadReport() {
    this.service.downloadUnknowRequestsFile(this.datePipe.transform(this.startDate, "yyyy-MM-dd"), this.datePipe.transform(this.endDate, "yyyy-MM-dd"), this.channel, this.language);
    // var link = document.createElement("a");
    // link.download = "Report.csv";
    // link.href = this.env.baseUrl + `requests/unknown_requests/export?from=${this.datePipe.transform(this.startDate, "yyyy-MM-dd")}&to=${this.datePipe.transform(this.endDate, "yyyy-MM-dd")}&ChannelName=${this.channel}&language=${this.language}`;
    // this.startDate = new Date();
    // this.endDate = new Date();
    // link.click();
    this.showHideExportDiv = !this.showHideExportDiv;
  }

  onChangeSearchOption(event: any) {
    this.UnknownRequestTable.searchType = event;
    this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
    this.GetUnknownRequestList();
  }

  sortData(event: any) {
    // console.log("event ", event)
    // this.UnknownRequestTable.sortByCol = event;
    // this.UnknownRequestTable.sortByType = this.UnknownRequestTable.sortByType == "DESC" ? "ASC" : "DESC";
    // this.GetUnknownRequestList();
  }

  _setDateFilterToToday() {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = new Date();
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.timeRange.selectedDates.to);
    this.timeRange.displayNameOfSelected = "Today";
    this.timeRange.displayNameOfSelectionInProgress = "Today";
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime();
    this.onDateFilterSubmit();
  }

  _setDateFilterToYesterday() {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = this.getAfterSettingTimeToMax(this.getDateSubstractingDaysToTheGiven(new Date(), 1));
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.timeRange.selectedDates.to);
    this.timeRange.displayNameOfSelected = "Yesterday";
    this.timeRange.displayNameOfSelectionInProgress = "Yesterday";
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + this.timeRange.selectedDates.to.getTime();
    this.onDateFilterSubmit();
  }

  _setDateFilterToLastNDays(n) {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = this.getAfterSettingTimeToMax(new Date());
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.getDateSubstractingDaysToTheGiven(this.timeRange.selectedDates.to, n - 1));
    this.timeRange.displayNameOfSelected = `Last ${n} Days`;
    this.timeRange.displayNameOfSelectionInProgress = `Last ${n} Days`;
    this.timeRange.nDays = n;
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + this.timeRange.selectedDates.to.getTime();
    this.onDateFilterSubmit();
  }

  _setPredefinedDate(timeRange: any) {
    if (timeRange.displayNameOfSelected == "Today") {
      this._setDateFilterToToday();
    }
    else if (timeRange.displayNameOfSelected == "Yesterday") {
      this._setDateFilterToYesterday();
    }
    else if (timeRange.displayNameOfSelected.startsWith("Last")) {
      this._setDateFilterToLastNDays(timeRange.nDays);
    }
    else {
      this.timeRange = timeRange;
    }
  }

  getAfterSettingTimeToZero(date: Date) {
    var copyOfDate: Date = new Date(date.getTime());
    copyOfDate.setHours(0, 0, 0, 0);
    return copyOfDate;
  }

  getAfterSettingTimeToMax(date: Date) {
    var copyOfDate: Date = new Date(date.getTime());
    copyOfDate.setHours(23, 59, 59, 999);
    return copyOfDate;
  }

  getDateRangeDisplayString(): string {
    return this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to)
  }

  getFilters() {
    return this.timeRange;
  }

  private getDateSubstractingDaysToTheGiven(givenDate: Date, daysToAdd: number): any {
    let copyOfGivenDate: Date = new Date(givenDate.getTime());
    return new Date(copyOfGivenDate.setDate(givenDate.getDate() - daysToAdd));
  }

  maxEndDateRange = new Date();
  onPageFilterDateFromSelect(event: Date) {
    var selectedDate = this.getAfterSettingTimeToZero(event);
    this.timeRange.selectedDates.from = selectedDate;
    this.timeRange.displayNameOfSelectionInProgress = this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to)
    this.maxEndDateRange.setDate(this.timeRange.selectedDates.from.getDate());
    this.maxEndDateRange.setMonth(this.timeRange.selectedDates.from.getMonth());
    this.maxEndDateRange.setFullYear(this.timeRange.selectedDates.from.getFullYear());
    this.maxEndDateRange.setDate(this.timeRange.selectedDates.from.getDate() + 30);
    if (this.maxEndDateRange > new Date()) {
      this.maxEndDateRange = new Date();
    }
    this.onPageFilterDateToSelect(this.maxEndDateRange);
  }

  onPageFilterDateToSelect(event) {
    var selectedDate = this.getAfterSettingTimeToMax(event);
    this.timeRange.selectedDates.to = selectedDate;
    this.timeRange.displayNameOfSelectionInProgress = this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to)
  }

  onDatesFilterClosed() {
    // Moved to submit
    // this.pageFilters.timeRange.displayNameOfSelected = this.pageFilters.timeRange.displayNameOfSelectionInProgress;
    // this.onFiltersChanged();
  }

  onDateFilterSubmit() {
    if (this.datesFilterTrigger) {
      this.datesFilterTrigger.closeMenu();
    }
    this.timeRange.displayNameOfSelected = this.timeRange.displayNameOfSelectionInProgress;
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + "-" + this.timeRange.selectedDates.to.getTime();
    this.onFiltersChanged();
  }

  private onFiltersChanged() {
    this.persistPageFilters();
    this.resetUnkonwnRequestTable(1, this.UnknownRequestTable.pagination.limit);
    this.GetUnknownRequestList();
  }

  private persistPageFilters() {
    localStorage.setItem('timeRange', JSON.stringify(this.timeRange));
  }

  private getFormatedDateOrEmptyString(date: Date) {
    if (date == null || '') {
      return '';
    }
    else {
      return formatDate(date, 'mediumDate', 'en-US')
    }
  }

  private getPersistedPageFilters() {
    let timeRange = JSON.parse(localStorage.getItem('timeRange'));
    if (timeRange) {
      timeRange.selectedDates.to = new Date(timeRange.selectedDates.to);
      timeRange.selectedDates.from = new Date(timeRange.selectedDates.from);
    }
    return timeRange;
  }

  isEdited(element) {

    var edited = this.unknownRequests.find(u => u.document_id == element.document_id);

    if (element.updated) {
      if ((element.SkillLabel === edited.SkillLabel) && (element.comment === edited.comment)) {
        element.updated = false;
        this.cdr.detectChanges();
        return false;
      } else if ((!element.SkillLabel || (element.SkillLabel == '')) && (!edited.SkillLabel || (edited.SkillLabel == '')) && !element.comment && !edited.comment) {
        return false;
      } else if ((!element.SkillLabel || (element.SkillLabel == '')) && (edited.SkillLabel == '' || !edited.SkillLabel)) {
        if (!((element.comment == '') && edited.comment == '') && element.comment != edited.comment) {
          return true;
        }
        element.updated = false;
        this.cdr.detectChanges();
        return false;
      } else if ((element.SkillLabel == edited.SkillLabel) && (element.comment == '' || !element.comment) && (!edited.comment || edited.comment == '')) {
        element.updated = false;
        this.cdr.detectChanges();
        return false;
      }
      return true;
    }

    return false;
  }

  searchId = null;
  isLoading = false;
  onClickConverstations(id: any) {
    if(this.searchId == null || this.searchId != id) {
      this.isLoading = true;
      this.converstation = [];
      this.searchId = id;
      return this.service.getFullConversationList(id).subscribe((data: {}) => {
        if (data["status"] == 200) {
          this.converstation = data["data"];
        } else {
          this.notifier.notify("error", data["status_details"]);
        }
        this.isLoading = false;
      })
    }
  }

  GetConversationListForce() {
    // this.resetUserTable(1, this.ConversationTable.pagination.limit);
    // this.GetConversationList();
  }
}
